<template>
  <div
    class="toggle-user"
    v-clickoutside="handleClose">
    <!-- 已选择的语言 -->
    <div
      class="toggle-box"
      @click="selected = !selected"
      @mouseover="handleIconHover(true)"
      @mouseout="handleIconHover(false)">
      <div class="user-icon">
        <svg
          class="icon icon-user"
          aria-hidden="true">
          <use xlink:href="#icon-touxiang"></use>
        </svg>
      </div>
      <p class="user-name">
        {{ sessionInfo.userName }}
      </p>
      <div class="icon-box">
        <svg
          class="icon"
          aria-hidden="true"
          v-show="!selected"
        >
          <use :xlink:href="hoverIcon"></use>
        </svg>
        <svg
          class="icon"
          aria-hidden="true"
          v-show="selected"
        >
          <use xlink:href="#icon-xiangshang-bai"></use>
        </svg>
      </div>
    </div>
    <transition name="el-zoom-in-top">
      <ul
        class="mount-box"
        v-show="selected"
      >
        <li
          v-for="item in selectList"
          :key="item.id"
          class="mount-item"
          @click="handleClick(item)"
        >
          <span>{{ $t(item.text) }}</span>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import loginApi from '@/api/login'
// import { corporbankUrl } from '@/config/constants'
import { changeVersionByDomain } from '@/utils/domain'
export default {
  data () {
    return {
      selected: false,
      selectList: [{
        id: 'ServiceContact',
        text: '联系我们'
      }, {
        id: 'LoginOut',
        text: '安全退出'
      }, {
        id: 'ToggleVersion',
        text: '版本切换'
      }],
      iconHover: false
    }
  },
  computed: {
    ...mapState('home', ['sessionInfo']),
    ...mapGetters({
      userInfo: 'userInfo'
    }),
    hoverIcon () {
      return this.iconHover ? '#icon-xiangxia-bai' : '#icon-xiangxia-hui'
    }
  },
  mounted () {
  },
  methods: {
    ...mapMutations('login', ['RESET_LOGIN_STATE']),
    handleIconHover (type) {
      this.iconHover = type
    },
    handleClick (item) {
      const { id } = item
      this.selected = false
      // 联系我们
      if (id === 'ServiceContact') {
        this.$router.push({
          name: id
        })
      }
      // 安全登录
      if (id === 'LoginOut') {
        this.$tconfirm('您确定要退出网上银行吗?').then(_ => {
          this.$tconfirm('为安全起见，请检查是否已拔出USBKEY？').then(_ => {
            const { customerId, userId } = this.userInfo
            loginApi.loginOut({
              customerId,
              userId,
              currentBusinessCode: '00000001'
            }).then(res => {
              if (res) {
                this.RESET_LOGIN_STATE()
                this.$router.push({
                  name: 'Login'
                })
              }
            }).catch(err => {
              console.error(err)
            })
          })
        }).catch(_ => { })
      }
      // 版本切换
      if (id === 'ToggleVersion') {
        changeVersionByDomain()
      }
    },
    handleClose () {
      this.selected = false
    }
  }
}
</script>

<style scoped lang="less">
.toggle-user {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  user-select: none;
  .toggle-box {
    display: flex;
    align-items: center;
    height: 100%;
    .user-icon {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      // margin-left: 41px;
      .icon {
        width: 30px;
        height: 30px;
      }
    }
    .user-name {
      height: 16px;
      color: @white;
      font-size: 14px;
      margin-right: 10px;
      overflow: hidden;
      max-width: 126px;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
    .icon-box {
      display: flex;
      align-items: center;
      width: 10px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      > .icon {
        width: 10px;
        height: 7px;
      }
    }
  }
  .mount-box {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translateY(100%);
    z-index: 999;
    > .mount-item {
      position: relative;
      display: flex;
      align-items: center;
      width: 120px;
      height: 40px;
      background: @blueLess80;
      &:hover {
        background: @blue;
      }
      // &.active {
      //   background: #4a6aff;
      // }
      > img {
        width: 20px;
        height: 20px;
        margin-left: 15px;
      }
      > span {
        font-size: 14px;
        font-weight: 400;
        color: @white;
        line-height: 14px;
        margin-left: 10px;
        margin-right: 20px;
        white-space: nowrap;
      }

      > .icon {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        width: 12px;
        height: 12px;
      }
    }
  }
}
</style>
